module.exports = __webpack_public_path__ + "assets/img/track-bottom-text.d9f0a946.png";